<template>
  <footer role="contentinfo" class="relative z-1 border-t-2 border-[#000091]">
    <div class="bg-gray-50 py-8">
      <div class="container">
        <div class="grid grid-cols-1 md:grid-cols-6 text-xs gap-8">
          <div>
            <div class="font-bold mb-8">Les activités bénévoles</div>
            <div class="grid grid-cols-1 gap-4">
              <nuxt-link no-prefetch class="link" to="/activites/maraude">Maraude</nuxt-link>
              <nuxt-link no-prefetch class="link" to="/activites/soins-aux-animaux"
                >Soins aux animaux</nuxt-link
              >
              <nuxt-link
                no-prefetch
                class="link"
                to="/activites/alphabetisation-apprentissage-du-francais-fle"
                >Alphabétisation</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/activites/ramassage-de-dechets"
                >Ramassage de déchets</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/activites/soutien-scolaire-et-formation"
                >Soutien scolaire</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/activites/aide-aux-demarches-administratives"
                >Aides aux démarches administrative</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/activites/droit-et-conseil-juridique"
                >Droit et conseil juridique</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/activites/ecoute-aide-psychologique"
                >Ecoute / Aide psychologique</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/activites/evenementiel"
                >Événementiel</nuxt-link
              >
            </div>
          </div>
          <div class="md:col-span-2">
            <div class="font-bold mb-8">Le bénévolat en France</div>
            <div class="grid grid-cols-2 gap-4">
              <nuxt-link no-prefetch class="link" to="/villes/paris">Bénévolat Paris</nuxt-link>
              <nuxt-link no-prefetch class="link" to="/villes/lille">Bénévolat Lille</nuxt-link>
              <nuxt-link no-prefetch class="link" to="/villes/rouen">Bénévolat Rouen</nuxt-link>
              <nuxt-link no-prefetch class="link" to="/villes/toulouse"
                >Bénévolat Toulouse</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/villes/rennes">Bénévolat Rennes</nuxt-link>
              <nuxt-link no-prefetch class="link" to="/villes/grenoble"
                >Bénévolat Grenoble</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/villes/lyon">Bénévolat Lyon</nuxt-link>
              <nuxt-link no-prefetch class="link" to="/villes/montpellier"
                >Bénévolat Montpellier</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/villes/tours">Bénévolat Tours</nuxt-link>
              <nuxt-link no-prefetch class="link" to="/villes/marseille"
                >Bénévolat Marseille</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/villes/strasbourg"
                >Bénévolat Strasbourg</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/villes/dijon">Bénévolat Dijon</nuxt-link>
              <nuxt-link no-prefetch class="link" to="/villes/bordeaux"
                >Bénévolat Bordeaux</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/villes/angers">Bénévolat Angers</nuxt-link>
              <nuxt-link no-prefetch class="link" to="/villes/nancy">Bénévolat Nancy</nuxt-link>
              <nuxt-link no-prefetch class="link" to="/villes/nantes">Bénévolat Nantes</nuxt-link>
              <nuxt-link no-prefetch class="link" to="/villes/nice">Bénévolat Nice</nuxt-link>
              <nuxt-link no-prefetch class="link" to="/villes/caen">Bénévolat Caen</nuxt-link>
            </div>
          </div>

          <div class="md:col-span-2">
            <div class="font-bold mb-8">Organisations populaires</div>
            <div class="grid grid-cols-2 gap-4">
              <nuxt-link
                no-prefetch
                class="link"
                to="/reseaux/14-federation-francaise-des-banques-alimentaires"
                >Banques Alimentaires</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/reseaux/104-oxfam-france"
                >Oxfam France</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/organisations/2747-makesense"
                >Makesense</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/reseaux/20-article-1">Article 1</nuxt-link>
              <nuxt-link
                no-prefetch
                class="link"
                to="/organisations/6144-explorjob-association-avdtm"
                >AVDTM - ExplorJob</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/organisations/1784-jobirl">JobIRL</nuxt-link>
              <nuxt-link
                no-prefetch
                class="link"
                to="/reseaux/58-la-societe-protectrice-des-animaux-la-spa"
                >La SPA</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/reseaux/33-la-cravate-solidaire"
                >La Cravate Solidaire</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/reseaux/35-emmaus-france"
                >Emmaüs France</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/reseaux/8-secours-catholique"
                >Secours Catholique</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/reseaux/79-apf-france-handicap"
                >APF France handicap</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/reseaux/4-les-restos-du-coeur"
                >Restos du coeur</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/reseaux/17-federation-habitat-et-humanisme"
                >Habitat et Humanisme</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/reseaux/2-entourage">Entourage</nuxt-link>
              <nuxt-link
                no-prefetch
                class="link"
                to="/reseaux/15-federation-nationale-de-la-protection-civile"
                >Protection Civile</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/organisations/4561-mon-emile-association"
                >Mon Emile Association</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/reseaux/56-apprentis-dauteuil"
                >Apprentis d’Auteuil</nuxt-link
              >
              <nuxt-link no-prefetch class="link" to="/reseaux/46-pro-bono-lab"
                >Pro Bono Lab</nuxt-link
              >
            </div>
          </div>
          <div>
            <div class="font-bold mb-8">Liens utiles</div>
            <div class="grid grid-cols-1 gap-4">
              <a class="link" target="_blank" href="https://reserve-civique.crisp.help/fr/"
                >Centre d'aide</a
              >
              <nuxt-link no-prefetch class="link" to="/charte-reserve-civique"
                >Charte de la Réserve Civique</nuxt-link
              >
              <a
                class="link"
                target="_blank"
                href="https://www.jeveuxaider.gouv.fr/fresque-benevolat"
                >Fresque du Bénévolat</a
              >
              <a
                class="link"
                target="_blank"
                href="https://www.jeveuxaider.gouv.fr/engagement/actualites/"
                >Actualités du bénévolat</a
              >
              <a
                class="link"
                target="_blank"
                href="https://www.jeveuxaider.gouv.fr/engagement/communication/"
                >Communication</a
              >
              <a
                class="link"
                target="_blank"
                href="https://www.jeveuxaider.gouv.fr/engagement/organisations/"
                >Partenaires</a
              >
              <a
                class="link"
                target="_blank"
                href="https://www.jeveuxaider.gouv.fr/engagement/presse/"
                >Presse</a
              >
              <a
                class="link"
                target="_blank"
                href="https://www.jeveuxaider.gouv.fr/engagement/campagnes-mobilisation-nationale/"
                >Campagnes de mobilisation</a
              >
              <nuxt-link
                no-prefetch
                class="link"
                :to="`/stats?start_date=${$dayjs()
                  .subtract(1, 'year')
                  .format('YYYY-MM-DD')}&end_date=${$dayjs().format('YYYY-MM-DD')}`"
                >Statistiques</nuxt-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white py-8">
      <div class="container">
        <div class="lg:flex lg:justify-between lg:items-center lg:gap-8">
          <div class="">
            <nuxt-link
              no-prefetch
              to="/"
              class="flex flex-col flex-wrap gap-4 sm:gap-6 sm:flex-row lg:gap-8 xl:gap-12"
            >
              <img
                src="@/assets/images/republique-francaise-logo.svg"
                alt="République Française"
                width="6500"
                height="5870"
                class="w-[76px] lg:w-[127px]"
              />

              <img src="@/assets/images/jeveuxaider-logo.svg" alt="" width="251" height="41" />
            </nuxt-link>
          </div>

          <div class="max-w-[600px]">
            <div class="text-[#383838] text-sm lg:max-w-lg leading-relaxed mt-8 mb-6">
              Trouvez une mission d'intérêt général auprès d'un organisme public
              <br class="hidden md:block" />
              ou associatif et faites vivre les valeurs de la République.
            </div>

            <div class="flex flex-wrap gap-3">
              <a
                v-for="link in gouvLinks"
                :key="link.url"
                class="hover:underline flex items-center gap-1 font-bold text-sm text-[#3A3A3A] mr-2"
                :href="link.url"
                target="_blank"
                rel="noopener"
              >
                {{ link.name }}
                <RiExternalLinkLine class="relative top-[-1px] h-4 w-4 fill-current" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="bg-white py-4">
      <div class="container">
        <div class="text-gray-600 text-xs">
          <div class="divide-x">
            <nuxt-link
              no-prefetch
              class="pl-0 cursor-pointer hover:underline pr-3 my-1 inline-block"
              to="/accessibilite"
              >Accessibilité : partiellement conforme</nuxt-link
            >
            <nuxt-link
              no-prefetch
              class="cursor-pointer hover:underline px-3 my-1 inline-block"
              to="/politique-de-confidentialite"
              >Données personnelles</nuxt-link
            >
            <nuxt-link
              no-prefetch
              class="cursor-pointer hover:underline px-3 my-1 inline-block"
              to="/mentions-legales"
              >Mentions légales</nuxt-link
            >
            <nuxt-link
              no-prefetch
              class="cursor-pointer hover:underline px-3 my-1 inline-block"
              to="/conditions-generales-d-utilisation"
              >CGU</nuxt-link
            >
            <nuxt-link
              no-prefetch
              class="cursor-pointer hover:underline px-3 my-1 inline-block"
              to="/charte-bon-fonctionnement/responsables"
              >Charte de bon fonctionnement</nuxt-link
            >
            <nuxt-link
              no-prefetch
              class="cursor-pointer hover:underline px-3 my-1 inline-block"
              to="/plan-du-site"
              >Plan du site</nuxt-link
            >
            <a
              class="cursor-pointer hover:underline px-3 my-1 inline-block"
              href="javascript:openAxeptioCookies()"
              >Gestion des cookies</a
            >
          </div>

          <div class="mt-6">
            Sauf mention contraire, tous les textes de ce site sont sous
            <a
              href="https://github.com/etalab/licence-ouverte/blob/master/LO.md"
              target="_blank"
              class="inline-flex items-baseline"
            >
              <span class="underline">licence etatlab-2.0</span>
              <ExternalSvg class="flex-none ml-1" width="10" height="10" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import ExternalSvg from '@/components/icon/External.vue'

export default defineNuxtComponent({
  components: {
    ExternalSvg,
  },
  methods: {},
  data() {
    return {
      gouvLinks: [
        {
          name: 'legifrance.gouv.fr',
          url: 'https://legifrance.gouv.fr',
        },
        {
          name: 'gouvernement.fr',
          url: 'https://gouvernement.fr',
        },
        {
          name: 'service-public.fr',
          url: 'https://service-public.fr',
        },

        {
          name: 'data.gouv.fr',
          url: 'https://www.data.gouv.fr',
        },
        {
          name: 'snu.gouv.fr',
          url: 'https://www.snu.gouv.fr/',
        },
        {
          name: 'service-civique.gouv.fr',
          url: 'https://www.service-civique.gouv.fr/',
        },
        {
          name: 'api-engagement.beta.gouv.fr',
          url: 'https://api-engagement.beta.gouv.fr/',
        },
        {
          name: 'associations.gouv.fr',
          url: 'https://associations.gouv.fr/',
        },
      ],
    }
  },
})
</script>

<style lang="postcss" scoped>
.link {
  @apply hover:underline text-gray-600 truncate;
}
</style>
